import ResizeService from './ResizeService'
export default class SingletonClass {
    static _instance = new SingletonClass()
    root = document.querySelector(":root");
    constructor() {
        SingletonClass._instance = this
        ResizeService.getInstance().add(this.changeSize.bind(this))
    }


    changeSize(_w, _h, _dir){//r2560x1600
        console.log('changeSize',_w,_h,_dir)
        const da=_dir.substr(1).split('x')
        if(da.length===2){
            if(_w/_h>Number(da[0])/Number(da[1])){
                this.root.style['fontSize']=`${_h/da[1]*14*2}px`
            }else{
                this.root.style['fontSize']=`${_w/da[0]*14*2}px`
            }
        }
    }
    static getInstance() {
        return SingletonClass._instance
    }

}